import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
const clients = [{
  name: 'Cliente 1',
  logo: 'https://via.placeholder.com/150x60/1e293b/ffffff?text=Cliente+1'
}, {
  name: 'Cliente 2',
  logo: 'https://via.placeholder.com/150x60/1e293b/ffffff?text=Cliente+2'
}, {
  name: 'Cliente 3',
  logo: 'https://via.placeholder.com/150x60/1e293b/ffffff?text=Cliente+3'
}, {
  name: 'Cliente 4',
  logo: 'https://via.placeholder.com/150x60/1e293b/ffffff?text=Cliente+4'
}, {
  name: 'Cliente 5',
  logo: 'https://via.placeholder.com/150x60/1e293b/ffffff?text=Cliente+5'
}, {
  name: 'Cliente 6',
  logo: 'https://via.placeholder.com/150x60/1e293b/ffffff?text=Cliente+6'
}];
export function Clients() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="clientes" ref={ref} className="py-24 px-6 bg-white scroll-mt-20" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-4">
            Algunos de nuestros clientes
          </h2>
          <p className="text-xl text-slate-600" data-id="element-5">
            Empresas que confían en nosotros
          </p>
          <p className="text-base text-slate-500 mt-2" data-id="element-6">
            Ayudamos a pequeñas, medianas y grandes empresas de distintas
            industrias en todo el país.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center" data-id="element-7">
          {clients.map((client, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center justify-center p-6 bg-slate-50 rounded-lg" data-id="element-8">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rbqnTT3WAHBizaFCFvc1JL/logo.png" alt={client.name} className="w-full h-auto opacity-60 hover:opacity-100 transition-opacity duration-300" data-id="element-9" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}